export function displayError(text:string, type:string){
    let errText = 'Что-то пошло не так :(';
    if (type === 'SERVER') {
        errText = 'Ошибка запроса к серверу: ' + text;
    } else {
        if (text) errText = text;
    }
    alert(errText);
}